export default {
  id: 'pricingScenarioBuilder',
  label: 'Pricing Lab',
  stores: {},
  globalComponents: {},
  routes: ['PricingScenarioBuilder'],
  nav: [{ label: 'Pricing Lab', routeName: 'PricingScenarioBuilder', group: 'create' }],
}
